export class RatingDistributionElementModel {
    private readonly _count: number;
    private readonly _percentage: number;

    /**
     * @constructor
     * @param starCount - The number of times the star count appears in the rating distribution.
     * @param starTotalCount - The total number of stars in the rating distribution.
     * @description Creates a new instance of the model.
     */
    constructor(public readonly starCount: number, public readonly starTotalCount: number) {
        this._count = starCount;
        this._percentage = Math.round((starCount / starTotalCount) * 100);
    }

    /**
     * @method count
     * @description Returns the number of times the star count appears in the rating distribution.
     */
    public get count(): number {
        return this._count;
    }

    /**
     * @method percentage
     * @description Returns the overall percentage of the star count in the rating distribution.
     * @returns {number}
     */
    public get percentage(): number {
        return this._percentage;
    }
}